import { useRef, useEffect, useState } from "react"

import styles from "./stickyAside.module.scss"

function StickyBottomAside({ children, withClass }) {
  const asideRef = useRef()
  const [isTall, setIsTall] = useState(false) // only add stickybottom if panel is tall enough, otherwise use sticky top

  useEffect(()=>{
    if(!asideRef.current) { return }

    const observer = new ResizeObserver(()=>{
      if(typeof window !== "undefined") {
        const limit = window.innerHeight - 104;
        const current = asideRef.current.getBoundingClientRect()
        setIsTall(current.height > limit ? true : false) 
      }
    })

    observer.observe(asideRef.current)

    return ()=>{
      observer.disconnect()
    }
  },[])

  return (
    <aside className={`${isTall ? styles.asideStickyBottom : styles.asideStickyTop} ${withClass || ""}`} ref={asideRef}>
      {children}
    </aside>
  )
}

function StickyTopAside({ children, withClass }) {
  return (
    <aside className={`${styles.asideStickyTop} ${withClass || ""}`}>
      {children}
    </aside>
  )
}

export {
  StickyBottomAside,
  StickyTopAside
}